















































































































































































import {Component, Prop, Watch} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {GetPatAdmissionRecord} from "@/api/specialDictionary"

@Component
export default class Home extends AbpBase {
	@Prop() value: any
	data: any = this.value

	patient: any = {
		ans: [],
		patDryWeights: [],
		patient: {},
		patientAllergyHistory: [],
		patientInfectHistory: [],
		patientTumourHistory: [],
		patientVascularAccess: [],
		therapeutic: []
	}

	created() {
		this.getData()
	}

	currentYear = new Date().getFullYear()  //当前年，用来计算年龄

	private async getData() {
		let res = await GetPatAdmissionRecord({patientId: this.value.id})
		this.patient = res.objects
	}
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/home/home.vue